module.exports = __webpack_public_path__ + "media/palenque/tree_houses-fcb9fd53.jpg";